export default "__VITE_ASSET__CCKnxtAV__"